import ReactGA from 'react-ga4'; 

const useGAHandleClick = () => {
    const trackButtonClick = ({ category, action, label }: { category?: string; action?: string; label: string }) => {
        ReactGA.event({
            category: category || 'Button', 
            action: action || 'Clicked', 
            label: label,
        });
    };

    return trackButtonClick;
};

export default useGAHandleClick;
